import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deletePartnerSplitSupplyNotice,
  listPartnerSplitSupplyNotices,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 他社の通告値の削除 (登録を地点・値ごと消す) mutation hook。 成功したら一覧を最新化する。
 * 詳細は消えた登録を指すので最新化しない (取り直すと見つからないエラーになる)。
 */
export function useDeletePartnerSplitSupplyNotice(): InvalidatingMutationResultFor<
  typeof deletePartnerSplitSupplyNotice
> {
  return useInvalidatingMutation(deletePartnerSplitSupplyNotice, [
    createConnectQueryKey({
      schema: listPartnerSplitSupplyNotices,
      cardinality: 'finite',
    }),
  ])
}
